const dismissPrefix = 'mto_survey_dismissed_';

const dismissKey = (surveyId: string) => dismissPrefix + surveyId;

/**
 * Dismissing the login survey (close icon / outside click) is remembered for the
 * current browser tab only, so a page reload does not re-open it straight away —
 * startup is fetched on every page load, not just after a login. It is cleared on
 * login and logout, so the survey is presented again at the next login.
 *
 * sessionStorage can throw (private mode, blocked site data), so every access is
 * guarded — a failure just means the popup reappears sooner.
 */
export function wasSurveyDismissed(surveyId: string) {
  try {
    return !!window.sessionStorage.getItem(dismissKey(surveyId));
  } catch {
    return false;
  }
}

export function rememberSurveyDismissed(surveyId: string) {
  try {
    window.sessionStorage.setItem(dismissKey(surveyId), '1');
  } catch {
    // ignore — the popup then simply reappears on the next page load
  }
}

/** Drops every remembered dismissal. Called when a session starts or ends. */
export function clearSurveyDismissals() {
  try {
    const keys: Array<string> = [];
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i);
      if (key?.startsWith(dismissPrefix)) keys.push(key);
    }
    keys.forEach(key => window.sessionStorage.removeItem(key));
  } catch {
    // ignore — nothing to clean up if session storage is unavailable
  }
}
